import "core-js/modules/es.object.to-string";
import { ROUTE_NAME } from '@/lib/constant';
import Loading from '@/pages/extra/loading.vue';
export default [{
  path: '/plant_tree/list',
  name: ROUTE_NAME.PLANT_TREE_LIST,
  meta: {
    title: '我的树苗',
    scrollBehavior: 'restore',
    scrollDefaultPosition: 0
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "plantTree" */
      '@/pages/plantTree/list.vue'),
      loading: Loading
    };
  }
}, {
  path: '/plant_tree/index',
  name: ROUTE_NAME.PLANT_TREE_INDEX,
  meta: {
    title: '邀请好友公益种树',
    scrollBehavior: 'restore',
    scrollDefaultPosition: 0
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "plantTree" */
      '@/pages/plantTree/index.vue'),
      loading: Loading
    };
  }
}];